import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'https://supportbackend.sharre-empire.com';

export function createApi(token, productSlug) {
  return axios.create({
    baseURL: `${BACKEND_URL}/api/widget`,
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Product-Slug': productSlug,
    },
  });
}
